import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { Router,ActivatedRoute } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { DashboardService } from '../../services/dashboard.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { EvaluacionService } from '../../services/evaluacion.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';


const ELEMENT_DATA: any[] = [];


@Component({
    selector   : 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls  : ['./dashboard.component.scss'],
    animations   : fuseAnimations
})
export class DashboardComponent
{
    displayedColumns: string[] = ['nombre', 'version','dueno','fechaInicio','fechaFin','ver'];
    dataSource = ELEMENT_DATA;
    preiniciadas = 0;
    iniciadas = 0;
    completadas = 0;
    aprobadas = 0;
    cerradas = 0;
    atrasadas = 0;
    vencenHoy = 0;
    enFecha = 0;
    totalEvaluaciones = 0;

    mainChart = [];
    widget8: any = {};
    filtro: FormGroup;
    customColors: any;

    view: any[] = [200, 200];
    showLegend: boolean = false;
    showLabels: boolean = false;
    label: string ="";

    colorSchemePreIniciadas = {
      domain: ['#5AA454']
    };

    pieDataPreIniciadas = [];

    colorSchemeIniciadas = {
      domain: ['#5AA454']
    };

    pieDataIniciadas = [];

    colorSchemeCompletadas = {
      domain: ['#5AA454']
    };

    pieDataCompletadas = [];

    colorSchemeAprobadas = {
      domain: ['#5AA454']
    };

    pieDataAprobadas = [];

    colorSchemeFinalizadas = {
      domain: ['#5AA454']
    };

    pieDataFinalizadas = [];

    @ViewChild('drawer') sidenav: MatDrawer;
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    selection: any;

    constructor(
                private _fuseProgressBarService: FuseProgressBarService,
                public dialog: MatDialog,
                private dashboardService: DashboardService,
                private _snackBar: MatSnackBar,
                public router: Router,
                private service: EvaluacionService,
                private route: ActivatedRoute,
                private _formBuilder: FormBuilder,
                ) {

                  this.customColors = this.setCustomColors();
                }

    ngOnInit() {

      this.dataSource = [];
      this._fuseProgressBarService.show();

      this.filtro = this._formBuilder.group({
        estructura: [],
        dueno: [],
        creador: [],
        fechaInicioDesde: [],
        fechaInicioHasta: [],
        fechaFinDesde: [],
        fechaFinHasta: [],
        estado: 'COMPLETADO'
      });

      this.service.getAllMy(this.filtro).pipe().subscribe(req => {

        req.body.map( evaluacion => {

          var evaluacionData = {
            id: evaluacion.id,
            nombre: evaluacion.nombre,
            version: evaluacion.version,
            estructuraJerarquica: evaluacion.estructuraJerarquica,
            fechaCreado: evaluacion.fechaCreado,
            nodoEstructuraJerarquica: evaluacion.nodoEstructuraJerarquica,
            escenario: evaluacion.escenario,
            owner: evaluacion.owner,
            fechaInicio: evaluacion.fechaInicio,
            fechaFin: evaluacion.fechaFin,
            estado: evaluacion.estado,
            tipo: evaluacion.tipo,
            creador: evaluacion.creador
          };

          this.dataSource.push(evaluacionData);
        });
        this.dataSource = [...this.dataSource];
        this._fuseProgressBarService.hide();
      });


      this.widget8 = {
          legend       : false,
          explodeSlices: false,
          labels       : false,
          doughnut     : false,
          gradient     : false,
          scheme       : {
              domain: ['#000000','#f44336', '#ff9800', '#ffeb3b', '#4caf50']
          },
          onSelect     : (ev) => {
              console.log(ev);
          }
      };



      this.service.countMyVencenHoy().pipe().subscribe(req => {

        this.vencenHoy = req.body;
      });

      this.service.countMyAtrasadas().pipe().subscribe(req => {

        this.atrasadas = req.body;
      });

      this.service.countMyEnFecha().pipe().subscribe(req => {

        this.enFecha = req.body;
      });

      this.service.statisticsMy().pipe().subscribe(req => {
        //this.dataSource = req.body;
        //this.dataSource.sort((a, b) => (a.fecha > b.fecha) ? 1 : -1);
        req.body.forEach(element => {

          if(element.estado =='PRE_INICIADO'){
            this.preiniciadas = element.cantidad;
            this.totalEvaluaciones += element.cantidad;
          }

          if(element.estado =='INICIADO'){
            this.iniciadas = element.cantidad;
            this.totalEvaluaciones += element.cantidad;
          }

          if(element.estado =='COMPLETADO'){
            this.completadas = element.cantidad;
            this.totalEvaluaciones += element.cantidad;
          }

          if(element.estado =='APROBADO')
          {
            this.aprobadas = element.cantidad;
            this.totalEvaluaciones += element.cantidad;
          }

          if(element.estado =='CERRADO'){
            this.cerradas = element.cantidad;
            this.totalEvaluaciones += element.cantidad;
          }

        });

        this.pieDataPreIniciadas.push({'name':"Preiniciadas",'value':(this.preiniciadas/this.totalEvaluaciones)});
        this.pieDataIniciadas.push({name:"Iniciadas",value:(this.iniciadas/this.totalEvaluaciones)});
        this.pieDataCompletadas.push({name:"Completadas",value:(this.completadas/this.totalEvaluaciones)});
        this.pieDataAprobadas.push({name:"Aprobadas",value:(this.aprobadas/this.totalEvaluaciones)});
        this.pieDataFinalizadas.push({name:"Cerradas",value:(this.cerradas/this.totalEvaluaciones)});

        this.mainChart = [
            {
                'name' : 'Preiniciadas',
                'value': this.preiniciadas
            },
            {
                'name' : 'Iniciadas',
                'value': this.iniciadas
            },
            {
                'name' : 'Completadas',
                'value': this.completadas
            },
            {
                'name' : 'Aprobadas',
                'value': this.aprobadas
            },
            {
                'name' : 'Cerradas',
                'value': this.cerradas
            }
        ];
      });
    }

    setCustomColors() {
      //'#000000','#f44336', '#ff9800', '#ffeb3b', '#4caf50'
    let result: any[] = [{"name": "Preiniciadas","value":"#000000"},
                         {"name": "Iniciadas","value":"#f44336"},
                         {"name": "Completadas","value":"#ffeb3b"},
                         {"name": "Aprobadas","value":"#ff9800"},
                         {"name": "Cerradas","value":"#4caf50"}];

    return result;
 }


    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }
}
